import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CurrencyInput from "react-currency-input-field";

function AnticiposProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");
  const [moneda, setMoneda] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [valueProveedor, setValueProveedor] = useState(null);
  // Se puede llegar desde EstadoCuentaCXP con el proveedor ya elegido:
  //   /AnticiposProveedoresCreate?proveedor=<id>
  const [selectedProveedor, setSelectedProveedor] = useState(() => {
    if (typeof window === "undefined") return "";
    return new URLSearchParams(window.location.search).get("proveedor") || "";
  });
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [importe, setImporte] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [formaPago, setFormaPago] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setBancos(res.data || []))
      .catch((err) => console.log(err));

    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setProveedores(res.data || []))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!selectedProveedor) {
      setOrdenesCompra([]);
      setSelectedOC("");
      return;
    }
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (o) =>
            o.proveedores?.[0]?._id === selectedProveedor &&
            o.is_active === "Si"
        );
        setOrdenesCompra(ocs);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) setMoneda(a.moneda);
    });
  }

  const saveAnticipo = (event) => {
    event.preventDefault();
    if (!selectedProveedor || !selectedBanco || Number(importe) <= 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes completar Proveedor, Banco e Importe",
      });
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        URL_ANTICIPOS,
        {
          fecha,
          importe: Number(importe),
          formaPago,
          bancos: selectedBanco,
          proveedores: selectedProveedor,
          ordenesCompra: selectedOC || null,
          utilizado: 0,
          saldo: Number(importe),
          tipoCambio: Number(tipoCambio) || 1,
          tipo: "Proveedor",
          observaciones: "NA",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data) => {
        axios
          .post(
            `${URL_MOVIMIENTOS_BANCOS}`,
            {
              fecha,
              importe: -Number(importe),
              tipo: "Egreso",
              bancos: selectedBanco,
              anticipos: data.data._id,
              moneda,
              tipoCambio: 1,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .catch((err) => console.log(err));

        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Anticipo Proveedor",
            detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Importe: ${importe}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.href = "/ListadoAnticiposProveedores";
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0]?.toUpperCase() || "0";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.anticiposCreate || user.pagoProveedores ? (
        <div className="container">
          <div className="card container col-sm-8">
            <h3 align="center">Nuevo Anticipo a Proveedor</h3>
            <Form onSubmit={saveAnticipo}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Row>
                  <Col md={3}>
                    <Label className="mr-sm-2">Fecha</Label>
                    <Input
                      type="date"
                      value={fecha}
                      required
                      onChange={(e) => setFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Tipo de Cambio</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={tipoCambio}
                      onChange={(e) => setTipoCambio(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Proveedor</Label>
                    <Autocomplete
                      size="small"
                      value={valueProveedor}
                      onChange={(event, sel) => {
                        if (sel) {
                          setValueProveedor(sel);
                          setSelectedProveedor(sel._id);
                        } else {
                          setValueProveedor(null);
                          setSelectedProveedor("");
                        }
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre_comercial}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Orden de Compra (opcional)</Label>
                    <Input
                      type="select"
                      value={selectedOC}
                      onChange={(e) => setSelectedOC(e.target.value)}
                      disabled={!selectedProveedor}
                    >
                      <option value="">Sin OC</option>
                      {ordenesCompra
                        .sort((a, b) =>
                          a.idOrdenCompra < b.idOrdenCompra ? 1 : -1
                        )
                        .map((a) => (
                          <option value={a._id}>
                            OC #{a.idOrdenCompra} / Fecha {a.fecha} / Total $
                            {Number(a.total_general).toFixed(2)}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Label className="mr-sm-2">Forma de Pago</Label>
                    <Input
                      type="select"
                      value={formaPago}
                      onChange={(e) => setFormaPago(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      <option value="Efectivo">Efectivo</option>
                      <option value="Transfer">Transfer</option>
                      <option value="TDC">TDC</option>
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label className="mr-sm-2">Banco</Label>
                    <Input
                      type="select"
                      value={selectedBanco}
                      onChange={(e) => jalaBanco(e.target.value)}
                    >
                      <option value="">Selecciona un Banco</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((a) => (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Label className="mr-sm-2">Importe</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={importe}
                      className={`form-control`}
                      onValueChange={(value) => setImporte(value)}
                    />
                  </Col>
                </Row>
              </FormGroup>
              <br />
              <Row>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  href="/ListadoAnticiposProveedores"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Row>
            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default AnticiposProveedoresCreate;
